/** @prettier */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import TermsAndConditionsModal from '@xanadu/ui-shared/components/TermsAndConditionsModal';
import { displayModal } from '@xanadu/ui-shared/modules/modal/actions';
import {
  acceptTAndCChange,
  clearTermsFields,
} from '@xanadu/ui-shared/modules/termsAndConditions/actions';
import { loginRequest } from '@xanadu/ui-shared/modules/userSession/actions';

const mapDispatchToProps = {
  displayModal,
  loginRequest,
  acceptTAndCChange,
  clearTermsFields,
};

function mapStateToProps(state) {
  return {
    terms: state.getIn(['termsAndConditions', 'termsAndConditions']),
    userTerms: state.getIn(['termsAndConditions', 'userTerms']),
    acceptError: state.getIn(['termsAndConditions', 'acceptError']),
    windowWidth: state.getIn(['application', 'widthSize'], 0),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TermsAndConditionsModal));
